// Swiper core version + modules
// https://swiperjs.com/swiper-api#using-js-modules
import Swiper, { Navigation, Pagination, Autoplay, Keyboard, A11y } from 'swiper'

// Configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay, Keyboard, A11y])

// Swiper home
const swiperHome = new Swiper('.o-swiper-home', {
  // Navigation
  // https://swiperjs.com/swiper-api#navigation
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  // Pagination
  // https://swiperjs.com/swiper-api#pagination
  pagination: {
    el: '.swiper-pagination',
    dynamicBullets: true
  },
  // Autoplay
  // https://swiperjs.com/swiper-api#param-autoplay
  autoplay: {
    delay: 10000,
    pauseOnMouseEnter: true
  },
  // https://swiperjs.com/swiper-api#keyboard-control
  keyboard: {
    enabled: true,
    onlyInViewport: true
  },
  // Accessibility (a11y)
  // https://swiperjs.com/swiper-api#accessibility-a11y
  a11y: {
    enabled: true,
    prevSlideMessage: 'Vorherige Folie',
    nextSlideMessage: 'Nächste Folie'
  }
})

// Swiper logo
const swiperLogo = new Swiper('.o-swiper-logo', {
  // Default parameters
  loop: true,
  slidesPerView: 1,
  spaceBetween: 0,
  // Responsive breakpoints
  // https://swiperjs.com/swiper-api#param-breakpoints
  breakpoints: {
    // When window width is >= $screen-sm-size
    375: {
      slidesPerView: 2,
      spaceBetween: 0
    },
    // When window width is >= $screen-md-size:
    500: {
      slidesPerView: 3,
      spaceBetween: 0
    },
    // When window width is >= $screen-lg-size
    769: {
      slidesPerView: 4,
      spaceBetween: 0
    }
  },
  // Navigation
  // https://swiperjs.com/swiper-api#navigation
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  // Pagination
  // https://swiperjs.com/swiper-api#pagination
  pagination: {
    el: '.swiper-pagination',
    dynamicBullets: true
  },
  // Autoplay
  // https://swiperjs.com/swiper-api#param-autoplay
  autoplay: {
    delay: 3000,
    pauseOnMouseEnter: true
  },
  // https://swiperjs.com/swiper-api#keyboard-control
  keyboard: {
    enabled: true,
    onlyInViewport: true
  },
  // Accessibility (a11y)
  // https://swiperjs.com/swiper-api#accessibility-a11y
  a11y: {
    enabled: true,
    prevSlideMessage: 'Vorheriges Logo',
    nextSlideMessage: 'Nächstes Logo'
  }
})
